"use client";
import { solid } from "@areahub/icons";
import {
  Box,
  Center,
  Heading,
  HStack,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack,
  type StackProps,
} from "@chakra-ui/react";
import { type PropsWithChildren } from "react";
import { FaInfoCircle } from "react-icons/fa";

export interface ReportSubcategoryHeaderProps
  extends PropsWithChildren<StackProps> {
  title: string;
  icon: string;
  subtitle?: React.ReactNode;
  helpText?: string;
  colorScheme?: string;
}

export function ReportSubcategoryHeader({
  title,
  icon,
  subtitle,
  helpText,
  colorScheme,
  children,
  ...props
}: ReportSubcategoryHeaderProps) {
  return (
    <Stack
      flexDirection={{
        base: "column",
        md: "row",
      }}
      apply="styles.widgetStyles.card"
      p="6"
      alignItems={{
        base: "center",
      }}
      textAlign={{
        base: "center",
        md: "left",
      }}
      {...props}
    >
      <Center
        h="24"
        w="24"
        borderRadius="md"
        bg={`${colorScheme || "blue"}.300`}
        color={`white`}
      >
        <Box as={solid[icon]} h="16" w="16" />
      </Center>
      <Stack
        pl={{
          base: 0,
          md: "6",
        }}
        pr={{
          base: 0,
          md: "6",
        }}
        justifyContent="center"
        flex="1"
      >
        <HStack
          justifyContent={{
            base: "center",
            md: "flex-start",
          }}
        >
          <Heading as="h1" size="3xl" lineHeight="shorter" fontWeight="bold">
            {title}{" "}
          </Heading>
          {helpText && (
            <Popover>
              <PopoverTrigger>
                <Box
                  bgColor="transparent"
                  fontSize="sm"
                  alignSelf="flex-start"
                  color="blueGray.500"
                  _hover={{
                    color: "blue.500",
                  }}
                  cursor="pointer"
                >
                  <Box as={FaInfoCircle} />
                </Box>
              </PopoverTrigger>
              <PopoverContent
                bg="blue.100"
                p="4"
                fontSize="sm"
                fontWeight="medium"
              >
                <PopoverArrow />
                <PopoverBody>Disclaimer: {helpText}</PopoverBody>
              </PopoverContent>
            </Popover>
          )}
        </HStack>
        <Box>{subtitle}</Box>
      </Stack>
      <Center justifySelf="flex-end">{children}</Center>
    </Stack>
  );
}
